import React from 'react';
import { ShaderLines } from '../ui/ShaderLines';

const Footer = () => {
  return (
    <footer className="relative border-t border-zinc-900 bg-black pt-24 pb-12 overflow-hidden">
      {/* Background Layer: Shader Lines */}
      <div className="absolute inset-0 opacity-40">
        <ShaderLines />
      </div>
      
      {/* Dark overlay to ensure text readability in footer */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-black/80 to-black pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          <div className="col-span-1 md:col-span-2">
            <div className="text-xl font-bold tracking-tighter flex items-center gap-2 mb-4">
              <div className="w-2 h-2 bg-cyan-500 rounded-full"></div>
              phoinix<span className="text-zinc-500">.tech</span>
            </div>
            <p className="text-zinc-500 text-sm max-w-sm font-light">
              Deep architecture meets AI-native product thinking for complex digital systems. 
              Engineering the next generation of intelligent software.
            </p>
          </div>
          
          <div>
            <h4 className="text-white font-medium mb-4 text-sm">Services</h4>
            <ul className="space-y-2 text-sm text-zinc-500">
              <li><a href="#" className="hover:text-white transition-colors">System Architecture</a></li>
              <li><a href="#" className="hover:text-white transition-colors">AI Integration</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Product Engineering</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-medium mb-4 text-sm">Company</h4>
            <ul className="space-y-2 text-sm text-zinc-500">
              <li><a href="#" className="hover:text-white transition-colors">About</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Careers</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Contact</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-zinc-900/50 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-zinc-600">
          <p>&copy; {new Date().getFullYear()} Phoinix.tech. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-zinc-400 transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-zinc-400 transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;